module.exports = __webpack_public_path__ + "img/partner-api-hub.70d43032.svg";